import React, { useContext, useCallback } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Modal } from "../../../../../../../../components";
import FormContext from "../../../../../../../../context/formContext";
import { deleteConvention } from "../../../../../../../../store/conventionsSlice";
import { MODAL_ID } from "../../../../../../../../utils/constants";

/**
 * @desc Delete convention modal.
 */
export const DeleteConventionModal = ({ cname }) => {
  const dispatch = useDispatch();
  const { reset } = useContext(FormContext);

  // METHODS ------------------------------------------------------------------

  /**
   * @desc Delete convention on modal accept.
   */
  const handleDeleteConvention = useCallback(async () => {
    try {
      await dispatch(deleteConvention());
      reset();
      toast.success("Success");
    } catch (err) {
      toast.error(`Error: ${err.message}`);
    }
  }, [dispatch, reset]);

  // COMPONENT ----------------------------------------------------------------

  const modalProps = {
    id: MODAL_ID.DELETE_CONVENTION,
    header: "Delete a Convention",
    children: (
      <div className="delete-convention-text">
        <div>Are you sure you want to delete convention:</div>
        <p className="cname">{cname}</p>
        <div>This action is permanent and irreversible.</div>
      </div>
    ),
    ctaText: "YES, DELETE",
    showCancelButton: true,
    onClick: handleDeleteConvention,
  };

  return <Modal {...modalProps} />;
};

export default DeleteConventionModal;
